<script setup>
import {computed, ref, watch} from 'vue'
import { useI18n } from 'vue-i18n'

import FunnelStep from '@/components/FunnelStep.vue'
import InputFrequency from '@/components/funnelSteps/components/InputFrequency.vue'
import {useFormDataStore} from '@/stores/FormDataStore'
import {useSubscriptionsStore} from '@/stores/SubscriptionsStore'

const { t } = useI18n()

defineProps({
  id: {
    type: Number,
    required: true
  },
  isActive: {
    type: Boolean,
    required: true
  },
  isCompleted: {
    type: Boolean,
    required: true
  }
})

const formDataStore = useFormDataStore()
const subscriptionStore = useSubscriptionsStore()

const frequency = ref(formDataStore.selectedSubscription.code)

const emits = defineEmits(['onChangeClicked', 'onClickCompleteStep'])

const subscription = computed(() => formDataStore.selectedSubscription)
const variantSubscriptions = computed(() =>
    subscriptionStore.getVariants(formDataStore.selectedSubscription.id)
)

const getIntervalText = (subscriptionLength) => {
  let interval = {}
  switch (subscriptionLength) {
    case 7:
      interval = t('Weekly payment')
      break
    case 365:
      interval = t('Annual payment')
      break
    default:
      interval = t('Monthly payment')
      break
  }
  return interval
}

watch(frequency, (code) => {
  if (subscription.value.code === code) {
    formDataStore.setVariantSubscription('') // clear variant
  } else {
    formDataStore.setVariantSubscription(code) // set variant
  }
})
</script>

<template>
  <FunnelStep
      :id="id"
      :name="getIntervalText(formDataStore.selectedSubscriptionWithVariant.length)"
      :details="$t('Payment Frequency')"
      :is-active="isActive"
      :is-completed="isCompleted"
      @on-change-clicked="emits('onChangeClicked')"
  >
    <InputFrequency
        v-model="frequency"
        :label="getIntervalText(subscription.length).label"
        :subscription="subscription"
    />

    <template
        v-if="variantSubscriptions.length > 0"
    >
      <InputFrequency
          v-for="variantSubscription in variantSubscriptions"
          :key="`variant-${variantSubscription.code}`"
          v-model="frequency"
          :label="getIntervalText(variantSubscription.length).label"
          :subscription="variantSubscription"
      />
    </template>

    <div class="input-group button-group">
      <button
          @click="emits('onClickCompleteStep')"
          class="button button--large button--primary step-payment-method__button"
      >
        {{ $t('Continue to payment method') }}
      </button>
    </div>
  </FunnelStep>
</template>
